package com.essntl.features.profile.domain.use_case

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.profile.domain.repository.ProfileRepository
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import org.koin.core.annotation.Single

@Single
class GetCurrentUserUseCase(
    private val profileRepository: ProfileRepository,
    private val authRepository: AuthRepository,
) {
    private val _successEvent = MutableSharedFlow<ProfileModel>()
    val successEvent = _successEvent.asSharedFlow()

    private val _failureEvent = MutableSharedFlow<Throwable>()
    val failureEvent = _failureEvent.asSharedFlow()

    suspend fun get(
        getState: () -> State<ProfileModel> = { State.initial() },
        setState: (State<ProfileModel>) -> Unit = {},
        onSuccess: suspend (ProfileModel) -> Unit = {},
        onFailure: suspend (Throwable) -> Unit = {},
    ) {
        try {
            setState(getState().copy(isLoading = true))

            authRepository.getCurrentUserId()
                .onSuccess { userId ->
                    userId?.let { id ->
                        profileRepository.getById(id)
                            .onSuccess { profile ->
                                setState(State.success(profile))

                                onSuccess(profile)
                                _successEvent.emit(profile)
                            }
                            .onFailure { e ->
                                setState(State.failure(getState().data))

                                onFailure(e)
                                _failureEvent.emit(e)
                            }
                    }
                }

        } catch (e: CancellationException) {
            setState(State.failure(getState().data))

            onFailure(e)
            _failureEvent.emit(e)
        }
    }

}